import type { UploadParams } from '../type';
import {
  assertFile,
  createProgressSnapshot,
  getUploadConcurrency,
  getUploadPartSize,
  resolveUploadFileName,
  shouldUseMultipartUpload,
} from '../utils/utils';

interface OssSdkInstance {
  multipartUpload(
    name: string,
    file: File,
    options: Record<string, unknown>
  ): Promise<unknown>;
  cancel(): void;
}

export async function upload(
  instance: unknown,
  params: UploadParams
): Promise<unknown> {
  const oss = instance as OssSdkInstance;
  const file = assertFile(params.file);
  const fileName = resolveUploadFileName(params);
  const isMultipart = shouldUseMultipartUpload(file, params.maxSize);

  params.onCancel?.({ instance: null, cancel: () => oss.cancel() });

  return oss.multipartUpload(fileName, file, {
    progress: (progressValue: number) => {
      params.onUploadProgress?.(
        createProgressSnapshot(progressValue * file.size, file.size)
      );
    },
    parallel: isMultipart ? getUploadConcurrency(params.queueLength) : 1,
    partSize: isMultipart ? getUploadPartSize(params.partSize) : file.size,
  });
}
